webpackJsonp([88824193402093],{

/***/ 1600:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"VisitItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"itemType","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"VisitItemType","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-visit-item-input-c413dc682bacb406999b.js